// extracted by mini-css-extract-plugin
export default {"licenseIssueCounts":"EzKGqjaa8HI0AGuLIGDv","iconGreen":"vEHddwpd_8Lq369QYHR6","iconRed":"hiQ6oypB0ufsmVA2fpjz","iconYellow":"XWQKhh2XKPGm7AADrpwr"};